import { Logo } from "./Logo";
import { NAV, CONTACT, scrollToId } from "./data";

export const Footer = () => (
  <footer className="overflow-hidden bg-white pt-20" data-testid="site-footer">
    <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
      <div className="grid gap-10 border-b border-navy/12 pb-12 md:grid-cols-12">
        <div className="md:col-span-5">
          <Logo />
          <p className="mt-5 max-w-sm text-sm leading-relaxed text-slate-600">Global sourcing, indenting and international trading of ferrous and non-ferrous metal scrap.</p>
        </div>
        <div className="md:col-span-3">
          <p className="font-mono text-[11px] uppercase tracking-[0.22em] text-slate-500">Explore</p>
          <ul className="mt-4 space-y-2">
            {NAV.map((n) => (
              <li key={n.id}><button onClick={() => scrollToId(n.id)} className="link-underline text-sm text-navy" data-testid={`footer-link-${n.id}`}>{n.label}</button></li>
            ))}
          </ul>
        </div>
        <div className="md:col-span-4">
          <p className="font-mono text-[11px] uppercase tracking-[0.22em] text-slate-500">Contact</p>
          <a href={`mailto:${CONTACT.email}`} className="link-underline mt-4 inline-block text-sm text-navy" data-testid="footer-email-link">{CONTACT.email}</a>
          <p className="mt-2 text-sm text-slate-600">{CONTACT.phone}</p>
        </div>
      </div>
      <div className="flex flex-col justify-between gap-2 py-6 text-xs text-slate-500 sm:flex-row">
        <p>© {new Date().getFullYear()} Zenura Metals. All rights reserved.</p>
        <p>Trust · Transparency · Quality · Global Sourcing · Long-Term Partnerships</p>
      </div>
    </div>
    <p className="wordmark select-none text-center font-display font-extrabold leading-[0.8] tracking-[-0.05em]" aria-hidden="true">ZENURA</p>
  </footer>
);
